import { createContext, Dispatch, SetStateAction } from 'react';
import { IMessage, INlpResponse, ITopic } from '@common/types';

interface IChatContext {
  topics: Array<ITopic>;
  selectedTopic: string;
  setSelectedTopic: Dispatch<SetStateAction<string>>;
  messages: Array<IMessage>;
  responses: Array<{ id: number; response: INlpResponse }>;
  addMessage: (message: IMessage) => void;
  addResponse: (id: number, response: INlpResponse) => void;
}

const initialState: IChatContext = {
  topics: [],
  selectedTopic: '',
  setSelectedTopic: () => '',
  messages: [],
  addMessage: () => null,
  responses: [],
  addResponse: () => null,
};

export default createContext<IChatContext>(initialState);
